module.exports = __webpack_public_path__ + "static/media/reno-small-placeholder.60b037eb.webp";